
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from '@mui/material';

const CommonBreadcrumbs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const pathnames = pathname.split('/').filter(Boolean);

  return (
    <Breadcrumbs style={{ cursor: 'pointer' }}>
      {pathnames.length ? null : ( // <Link onClick={() => navigate('/')}>Dashboard</Link>
        <p> Home </p>
      )}
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? null : ( //   <Typography key={name}>{name}</Typography>
          <Link key={name} onClick={() => {
            if (index + 1 !== pathnames.length - 1) {
              navigate(routeTo)
            }

          }}>
            {name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default CommonBreadcrumbs;
